import * as types from './actionTypes'

export const fetchRelations = (id, pagetype) => ({
    type: types.RELATIONS_FETCH,
    id,
    pagetype
})

export const fetchRelationsSuccess = (data) => ({
    type: types.RELATIONS_FETCH_SUCCESS,
    data
})

export const fetchRelationsFailed = () => ({
    type: types.RELATIONS_FETCH_FAILED
})

export const createRelation = (from, to, verb, title) => ({
    type: types.RELATION_CREATE,
    from,
    to,
    verb,
    title
})

export const updateRelation = (id, verb) => ({
    type: types.RELATION_UPDATE,
    id,
    verb
})

export const updateRelationSuccess = (relation) => ({
    type: types.RELATION_UPDATE_SUCCESS,
    relation
})

export const updateRelationFailed = () => ({
    type: types.RELATION_UPDATE_FAILED
})
